// extracted by mini-css-extract-plugin
module.exports = {"section":"style_section__DS_Xp","disclaimer":"style_disclaimer__vRCCz","details":"style_details__Dz81I","images":"style_images__f1JAw"};